<template>
	<MainLayout>
		<div id="zoned-rate-editor" class="container">
			<div class="box">
				<!---<b-button class="mb-2" @click="$root.store.setRoute('/rate-plans')">Back</b-button>--->
				<div style="position: relative;">
					<div>
						<EditRates :rate-plan-id="ratePlanId" />
					</div>
				</div>
			</div>
		</div>
	</MainLayout>
</template>

<script>
import EditRates from './EditRates'
import MainLayout from '../layout/MainLayout'

export default {
		components: { MainLayout, EditRates },
		data(){
			let id = parseInt(this.$root.getParams().id)
			return {
				ratePlanId:id,
			}
		},
		computed : {
		},
		methods:{
		},
		mounted(){
		}
}
</script>

<style scoped>
</style>
<style >
	#zoned-rate-editor .card-body{
		background: #021D3E !important;
		color: white;
	}
</style>
